var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.pagination.totalPages > 1
    ? _c(
        "nav",
        {
          staticClass: "pagination",
          attrs: { role: "navigation", "aria-label": "pagination" }
        },
        [
          _c("ul", { staticClass: "pagination-list" }, [
            _c("li", { staticClass: "pagination-prev" }, [
              _c("button", {
                staticClass: "pagination-previous",
                attrs: {
                  disabled: _vm.pagination.pageIndex <= 1 ? "disabled" : false
                },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.changePage(_vm.pagination.pageIndex - 1)
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c(
              "li",
              { staticClass: "pagination-page", attrs: { taxindex: "0" } },
              [
                _vm._v(
                  "\n\t\t\t" +
                    _vm._s(_vm.pagination.pageIndex) +
                    " of " +
                    _vm._s(_vm.pagination.totalPages) +
                    "\n\t\t"
                )
              ]
            ),
            _vm._v(" "),
            _c("li", { staticClass: "pagination-next" }, [
              _c("button", {
                staticClass: "pagination-next",
                attrs: {
                  disabled:
                    _vm.pagination.pageIndex >= _vm.pagination.totalPages
                      ? "disabled"
                      : false
                },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.changePage(_vm.pagination.pageIndex + 1)
                  }
                }
              })
            ])
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }